export default __webpack_public_path__ + "static/hippaaLogo-e0243227a87f2059bb67adf3843e9934.png";